<template>
  <div>
    <h3>{{ text['0004'] }} 3/4</h3>
    <hr class="title">
    <h2>{{ text['0015'] }}</h2>

    <div class="tab-list">
      <div v-for="(category,acsqce) in filteredCategories" class="tab" :class="{ selected: acsqce === currentCategory }" @click="setCurrentCategory(acsqce)">
        <object v-if="acsqce === currentCategory" type="image/svg+xml" :data="`/assets/icons/${acsqce}-active.svg`"></object>
        <object v-else type="image/svg+xml" :data="`/assets/icons/${acsqce}.svg`"></object>
      </div>
    </div>


    <div v-for="(category,acsqce) in filteredCategories" class="survey-applications">
      <transition name="slide-app" mode="out-in" :key="acsqce">
        <div v-if="acsqce === currentCategory">
          <div v-for="(application,apsqce) in applications[acsqce].apps" @click="toggleApplicationSelection(apsqce)" class="survey" :class="{ selected: isSelected(acsqce,apsqce) }">
            <div>
              <img :src="`https://www.futech-tools.com/assets/img/imglsr/${application.apid}-XXX.jpg`">
            </div>
            <div>
              <p>{{ application.aptext }}</p>
            </div>
            <div class="checked">
              <object v-if="isSelected(acsqce,apsqce)" type="image/svg+xml" data="/assets/icons/checked.svg" ></object>
              <object v-else type="image/svg+xml" data="/assets/icons/unchecked.svg" ></object>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <li v-for="error in validationErrors">{{ error }}</li>

  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { mapActions } from 'vuex';

  export default {
    computed: {
      ...mapGetters({
        text: 'getText',
        currentCategory: 'application/getCurrentCategory',
        applications: 'application/getApplications',
        validationErrors: 'getErrors',
      }),
      filteredCategories() {
        const categoryArray = this.applications;
        let resultObject = {};
        for (const ackey in categoryArray) {
          if (categoryArray[ackey].selected) {
            resultObject[ackey] = categoryArray[ackey];
          }
        }
        return resultObject;
      },
    },
    methods: {
      ...mapActions({
        toggleApplicationSelection: 'application/toggleApplicationSelection',
        setCurrentCategory: 'application/setCurrentCategory',
      }),
      isSelected(categoryId,applicationId) {
        return this.applications[categoryId].apps[applicationId].selected;
      },
    },
  }
</script>

<style>
  .slide-app-enter {
    opacity: 0;
  }

  .slide-app-enter-active {
    animation: slide-app-in ease-out .3s;
    transition: opacity .3s;
  }

  .slide-app-leave {

  }

  .slide-app-leave-active {
    transition: opacity .2s;
    opacity: 0;
    position: absolute;
  }

  @keyframes slide-app-in {
    from {
      transform: translateX(500px);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes slide-app-out {

  }
</style>


// WEBPACK FOOTER //
// src/components/screens/Application.vue